import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import LowBatteryDetails from "./LowBatteryDetails";
import PropTypes from "prop-types";

const ChatItems = ({ className = "" }) => {
  const navigate = useNavigate();

  const onGroupContainerClick = useCallback(() => {
    navigate("/42-edit-profile");
  }, [navigate]);

  const onGroupContainerClick1 = useCallback(() => {
    navigate("/51-payment");
  }, [navigate]);

  return (
    <div
      className={`self-stretch flex flex-col items-start justify-start gap-[15px] max-w-full text-left text-21xl text-dark-text font-text-regular-lowercase ${className}`}
    >
      <div
        className="flex flex-row items-start justify-start gap-[3px] cursor-pointer"
        onClick={onGroupContainerClick}
      >
        <h1 className="m-0 relative text-inherit font-semibold font-[inherit]">
          Chào Nam
        </h1>
        <div className="flex flex-col items-start justify-start pt-[19px] px-0 pb-0">
          <img
            className="w-6 h-6 relative overflow-hidden shrink-0"
            loading="lazy"
            alt=""
            src="/mode-edit-outline.svg"
          />
        </div>
      </div>
      <div className="self-stretch flex flex-col items-start justify-start gap-10 max-w-full text-5xl text-light-text mq330:gap-5">
        <div className="flex flex-row items-start justify-start pt-0 px-0 pb-[25px] box-border max-w-full">
          <h3 className="m-0 relative text-inherit font-semibold font-[inherit]">
            Máy của bé My sắp hết pin!
          </h3>
        </div>
        <LowBatteryDetails
          lowBatteryDetailsBackgroundColor="#ffeaf7"
          lowBatteryDetailsPadding="22px 20px"
          rectangleDivBackgroundColor="#ffeaf7"
          device12LowBattery1="/chatgpt-image-13-29-24-5-thg-4-2025-1@2x.png"
          lastInteractionPadding="0px 0px 9px"
          myCaBMy="Máy của bé My"
          cuTLnCui="2000 câu từ lần cuối"
          blankLineColor="#565656"
          pin18FontFamily="'Be Vietnam Pro'"
          pin18FontSize="10px"
          blankLineFontFamily="'Be Vietnam Pro'"
          blankLineFontSize="10px"
          cuTLnCuiFontFamily="'Be Vietnam Pro'"
          xemLchSFontSize="10px"
          xemLchSFontFamily="'Be Vietnam Pro'"
        />
        <div className="self-stretch flex flex-col items-start justify-start max-w-full text-center text-sm text-light-primary-key-background">
          <LowBatteryDetails
            lowBatteryDetailsBackgroundColor="#fff2ea"
            lowBatteryDetailsPadding="21px 20px 23px"
            rectangleDivBackgroundColor="#fff2ea"
            device12LowBattery1="/device-2-1@2x.png"
            lastInteractionPadding="0px 0px 8px"
            myCaBMy="Máy mới cho Hùng"
            cuTLnCui="Hôm nay chưa nói"
            blankLineColor="#565656"
            pin18FontFamily="'Be Vietnam Pro'"
            pin18FontSize="10px"
            blankLineFontFamily="'Be Vietnam Pro'"
            blankLineFontSize="10px"
            cuTLnCuiFontFamily="'Be Vietnam Pro'"
            xemLchSFontSize="10px"
            xemLchSFontFamily="'Be Vietnam Pro'"
          />
          <div
            className="self-stretch flex flex-row items-start justify-start max-w-full cursor-pointer"
            onClick={onGroupContainerClick1}
          >
            <div className="flex-1 rounded-t-none rounded-b-xl bg-dark-orange flex flex-row items-start justify-start pt-[11px] pb-3 pl-5 pr-[19px] box-border max-w-full">
              <div className="h-10 w-[360px] relative rounded-t-none rounded-b-xl bg-dark-orange hidden max-w-full" />
              <div className="flex-1 relative leading-[120%] inline-block max-w-full z-[1]">
                Chưa thanh toán dịch vụ, free năm đầu tiên
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ChatItems.propTypes = {
  className: PropTypes.string,
};

export default ChatItems;
